<template>
  <div class="mainTabBox" style="height: 50px;font-size: 16px;z-index: 1000;">
    <!-- <div :class="['tabsMain', tabIdx==idx?'selectTab':'']" v-for="(tab,idx) in menuList" :key="idx" @click="changeTab(idx)">{{tab}}</div> -->
    <a-tooltip placement="bottom" :class="['tabsMain', tabIdx==idx?'selectTab':'']" v-for="(tab,idx) in menuList" :key="idx" @click="changeTab(idx)">
      <template slot="title" v-if="pathsText[idx]">
        {{ pathsText[idx] }}
      </template>
      {{tab}}
    </a-tooltip>
  </div>
</template>

<script>
export default {
  name: 'HeaderMenu',
  data () {
    return {
      menuList: ['活动介绍', '微能力培训', '课例观摩与解课', '认证及PK结果', '直播回顾'],
      tabIdx: 0,
      // paths: ['/home', '/microTrain', '/videoClass', '/matchResult', '/liveReview']
      paths: ['/home', '/microTrain', '/videoClass', '/matchResult', '/liveReview'],
      paths1: ['/home', '/microTrain', '/videoDetail', '/matchResult', '/liveReview'],
      pathsText: ['', '', '', '', ''],


    };
  },
  created () {
    this.paths1.map((item, idx) => {
      if (this.$route.path == item) {
        this.tabIdx = idx;
      }
    });
    this.paths.map((item, idx) => {
      if (this.$route.path == item) {
        this.tabIdx = idx;
      }
    });
    
  },
  methods: {
    changeTab (idx) {
      if (this.paths[idx]){
        this.tabIdx = idx;
        this.$router.push(this.paths[idx]);
      }
    },
    setIndex (){
      this.tabIdx = 2;
    }
  }
}
</script>

<style lang="less" scoped>
.mainTabBox {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
  .tabsMain {
    // height: 64px;
    // line-height: 64px;
    color: #333;
    margin: 0 26px;
    cursor: pointer;
  }
  .selectTab {
    color: #F5222D;
    border-bottom: 2px solid #F5222D;
  }
}
</style>
